module.exports = __webpack_public_path__ + "cr.svg?7f553c0ac6b72071c5360bb22408a88d";